<template>
    <span class="event-venue">
        {{ formattedLabel }}
    </span>
</template>

<script setup lang="ts">
const props = defineProps<{
    venues: VenueRelation[];
}>();

const { venues } = toRefs(props);

const formattedLabel = computed(() => {
    if (!venues.value || !venues.value.length || venues.value.length === 0) {
        return '';
    }

    if (venues.value.length === 1) {
        return venues.value[0].name + (venues.value[0].city? `, ${venues.value[0].city.name}` : '');
    }

    return 'Meerdere locaties';
});
</script>
